/**
 * Exemple d'utilisation
    new AjaxForm({
      $el: $('.the-form'),      // obligatoire
    });


    // Autres options (valeur par défaut)
    new AjaxForm({
        $el: $('.the-form'),
        messageSelector: {
            wrapper: '.js-main-messages-form',
            success: '.js-form-success',
            error: '.js-form-error',
        },
        formExtraClass: 'js-form-message-wrapper',      // Classe supplémentaire ajoutée sur le formulaire lors de l'affichage des messages
        formContentSelector: '.js-form-inner',
        loaderSelector: '.js-loader.is-ajax',
        fileuploadSelector: '.js-fileupload',
        rules: rulesConfig[name],                       // Configuration supplémentaire pour jQuery Validate https://jqueryvalidation.org/validate/#rules
        messages: messageConfig[name]                   // Configuration supplémentaire pour jQuery Validate https://jqueryvalidation.org/validate/#messages
    });


    // Exemple du HTML
    <form class="js-form-ajax" action="{{ url('/') }}/backend/atqc/repertory/jobs/submitApplication" data-module='ajax-form' data-name="job">
        <div class="js-form-inner">

            <div class="col-md-6 box-field">
                <div class="upload-file js-upload-file">
                    <label class="txt">
                        <span class="upload-file-txt js-uploadFile-txt"></span>
                        <span class="upload-file-txt js-uploadFile-txt-nofile">Téléverser votre CV (Format PDF, .DOC ou .DOCX)</span>
                    </label>
                    <input type="file" class="input-file js-input-file required js-cv" name="cv" id="cv" required>
                    <button class="upload-clear js-upload-clear is-hidden"><img src="{{ ('assets/images/ui/icone-close-red.svg')|api }}" alt=""></button>
                </div>
            </div>
        </div>

        <div class="main-messages-form js-main-messages-form">
            <p class="error js-form-error js-hide">
                <?php _e('Server error, please try again later', 'pn'); ?>
            </p>
            <p class="success js-form-success js-hide">
                <?php _e('Thank you for contacting us', 'pn'); ?>
            </p>
        </div>

        {% partial 'site/loader.htm' extra_class='js-loader is-ajax' %}
    </form>
 *
 */

(function($) {

    'use strict';

    function AjaxForm() {

        var self = this,
            $form = null,
            $loader = null,
            $checkboxList = null,
            $messages = null,
            $error = null,
            $success = null,
            formExtraClass = 'js-form-message-wrapper',
            formContentSelector = '.js-form-inner',
            fileuploadSelector = '.js-fileupload',
            rules = {},
            messages = {},
            options = {
                'example': null
            };

       /**
         * Generic resize
         */
        function onResize() {
            // Example
            if (window.bp.getLastValue() !== window.bp.getValue()) {
                if (window.bp.getValue() === 'xs' || window.bp.getValue() === 'sm') {
                    // Remove fixed height for messages
                    options.$el.removeAttr('style');
                }
            }
        }

        function showMessage() {
            // Hide fields
            $form.addClass(formExtraClass).find(formContentSelector).hide();

            // Show message
            $messages.show();
        }

        /**
         * Display success message
         */
        function showSuccessMessage() {
            showMessage();

            $error.fadeOut('fast');
            $success.fadeIn('fast');

            // Hide loader
            $loader.removeClass('is-active');
        }


        /**
         * Display error message
         * @param  {String} text
         */
        function showErrorMessage(text) {
            showMessage();

            if (text) {
                $error.html(text);
            } else {
                $error.html('Une erreur s\'est produite, réessayez ou communiquez avec nous.');
            }

            $error.fadeIn('fast');

            // Hide loader
            $loader.removeClass('is-active');
        }


        /**
         * Validate form, then send and show message according to response
         */
        var initValidation = function() {

            // https://jqueryvalidation.org/validate/

            // Validate form
            $form.validate({
                // debug: true,
                rules: rules,
                messages: messages,
                highlight: function(element, errorClass, validClass) {
                    var $element = $(element);

                    // Exception for input type file
                    if ($element.is('input[type="file"]')) {
                        $element.parents(fileuploadSelector).addClass(errorClass).removeClass(validClass);
                    } else {
                    // Default behavior
                        $element.addClass(errorClass).removeClass(validClass);
                        $(element.form).find("label[for=" + element.id + "]")
                          .addClass(errorClass);
                    }
                },
                unhighlight: function(element, errorClass, validClass) {
                    var $element = $(element);

                    // Exception for input type file
                    if ($element.is('input[type="file"]')) {
                        $element.parents(fileuploadSelector).removeClass(errorClass).addClass(validClass);
                    } else {
                    // Default behavior
                        $element.removeClass(errorClass).addClass(validClass);
                        $(element.form).find("label[for=" + element.id + "]")
                        .removeClass(errorClass);
                    }
                },
                errorPlacement: function (error, element) {
                    var $element = $(element);

                    // Exception for input type file
                    if ($element.is('input[type="file"]')) {
                        error.insertAfter($element.parents(fileuploadSelector));
                    // Exception for select2
                    } else if ($element.hasClass('js-select2')) {
                        error.insertAfter($element.next('.select2-container'));
                    } else {
                        // Default function
                        error.insertAfter(element);
                    }
                },
                submitHandler: function(form) {
                    var formData = new FormData($form[0]);
                    var action = $form.attr('action');
                    var sData = $form.serialize();

                    if (action === '') {
                        return;
                    }

                    // Save data for checkbox and radio button
                    if ($checkboxList.length > 0) {
                        for (var i = 0, length = $checkboxList.length; i < length; i++) {
                            formData.append($checkboxList[i].getAttribute('name'), $checkboxList[i].value);
                        }
                    }

                    if (window.bp.getValue() !== 'xs' && window.bp.getValue() !== 'sm') {
                        $form.height($form.innerHeight());
                    }

                    $loader.addClass('is-active');

                    // Send form
                    $.ajax({
                        method: 'POST',
                        url: action,
                        data: formData,
                        dataType: 'json',
                        cache: false,
                        contentType: false,
                        processData: false,
                        success: function(res) {
                            // Manual error from server
                            if (res.error) {
                                showErrorMessage(res.error);
                                
                                return false;
                            }

                            // Show message
                            if (res.success) {
                                showSuccessMessage();
                            }
                            $form.find('.js-form-main-content').hide();
                        },
                        error: function(errorThrown) {
                            // Show message
                            showErrorMessage(errorThrown);

                            return false;
                        }
                    });
                }
            });
        };


        /**
         * Public constructor
         * @param  {Object} opts Options
         */
        self.initialize = function(opts) {
            //extends options
            for (var i in opts) { options[i] = opts[i]; }

            // Manage default values
            var messageSelectorSuccess = options.messageSelector && options.messageSelector.success || '.js-form-success';
            var messageSelectorError = options.messageSelector && options.messageSelector.error || '.js-form-error';
            var messageSelectorWrapper = options.messageSelector && options.messageSelector.wrapper || '.js-main-messages-form';
            var loaderSelector = options.loaderSelector || '.js-loader.is-ajax';

            // Caching
            $form = options.$el;
            $success = $form.find(messageSelectorSuccess);
            $error = $form.find(messageSelectorError);
            $messages = $form.find(messageSelectorWrapper);
            formExtraClass = options.formExtraClass || formExtraClass;
            formContentSelector = options.formContentSelector || formContentSelector;
            fileuploadSelector = options.fileuploadSelector || fileuploadSelector;
            $loader = options.$el.find(loaderSelector);
            $checkboxList = options.$el.find('input[type="radio"]');
            rules = options.rules || {};
            messages = options.messages || {};


            // Initialize form
            initValidation();


            // Extend validator rules for jQuery Validate (to validate filesize in bytes)
            $.validator.addMethod('filesize', function(value, element, param) {
                // param = size (in bytes)
                // element = element to validate (<input>)
                // value = value of the element (file name)
                return this.optional(element) || (element.files[0].size <= param);
            });

            //*************
            window.cache.$window.on('resize', Utils.debounce(onResize, 400));
            onResize(); // initial call on load
        };

        self.initialize.apply(self, arguments);
        return self;
    }

    /* Namespace declaration */
    window.AjaxForm = AjaxForm;

}(jQuery));
